<template>
	<div class="help flex-center">
		<div class="gif-bg" id="helpBox"></div>
		<div class="content-div flex-col gap67" style="z-index: 2;">
			<div class="help-title font700 white">{{$t('生态')}}</div>
			<div class="flex-item gap25">
				<div class="help-item flex-col flex-center" v-for="(i,index) in list" :key="index">
					<img :src="i.img" alt="">
					<div class="help-text font24 white font700">{{i.text}}</div>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	export default {
		computed: mapState({
			screenSize(state) {
				return state.screenSize;
			},
			common(state) {
				return state.common;
			}
		}),
		data() {
			return {
				list: [{
						img: '../../../static/image/product/logo1.png',
						text: this.$t('社区团购')
					},
					{
						img: '../../../static/image/product/logo2.png',
						text: this.$t('社区小店')
					},
					{
						img: '../../../static/image/product/logo3.png',
						text: this.$t('社区空间')
					},
					{
						img: '../../../static/image/product/logo4.png',
						text: this.$t('社区服务')
					},
					{
						img: '../../../static/image/product/logo5.png',
						text:  this.$t('NECO优选')
					},

				]
			}
		},
		mounted() {

      this.$nextTick(() => {

        let colorbg = new Color4Bg.BlurGradientBg({
          dom: 'helpBox',
          colors: ['#1D4600', '#152900', '#005232', '#000f07'],
          loop: true
        })
      })

			// this.$nextTick(() => {
      //   let color1bg = new Color4Bg.BlurDotBg({
      //     dom: "helpBox",
      //     colors: ["#801300","#AE1E00","#D92800","#EB3131"],
      //     loop: true
      //   })
			// })

		}
	}
</script>

<style scoped>
	@media screen and (max-width: 768px) {
		.help {
			width: 100% !important;
			padding: 110px 0 60px 0 !important;
			height: calc(100vh - 110px - 60px) !important;
			position: relative;
			z-index: 3;
			display: flex;
			justify-content: space-between;
			align-items: center !important;
			overflow-y: auto;
			overflow-x: hidden;
		}

		.flex-item {
			display: flex;
			flex-direction: column;
			gap: 14px;
		}

		.help-item {
			padding: 16px 40px !important;
			width: calc(100% - 80px) !important;
			background-color: rgba(255,255,255,.16) !important;
			display: flex;
			flex-direction: row;
			gap: 28px !important;
			border: none;
			justify-content: flex-start;
		}

		.help-text {
			font-size: 16px !important;
			max-width: 100% !important;
		}
	}

	.help {
		width: 100%;
		height: 100vh;
		position: relative;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 3;
		display: flex;
		flex-direction: column;
		align-items: center;
		/* justify-content: center; */
		overflow-y: auto;
	}

	.video-background {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;
		z-index: 1;
	}

	.vedio-lobby {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.gap67 {
		gap: .67rem;
	}

	.help-title {
		font-size: .96rem;

	}

	.help-item {
		padding: .16rem .4rem;
		border-radius: .24rem;
		/*border: 1px solid rgba(76, 217, 100, 0.20);*/
		background: rgba(0, 0, 0, 0.30);
		gap: .24rem;
	}

	.help-item img {
		width: 1.2rem;
		height: 1.2rem;
	}

	.gif-bg {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2;
	}

	.help-text {
		max-width: 1.2rem;
		text-align: center;
		white-space: break-spaces;
	}

	.content-div {
		width: calc(100% - 1.2rem);
		padding: 0 .16rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/Help/index.vue